import { render, staticRenderFns } from "./ModalAddStep.vue?vue&type=template&id=78a96a1c&"
import script from "./ModalAddStep.vue?vue&type=script&lang=js&"
export * from "./ModalAddStep.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddStep.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78a96a1c')) {
      api.createRecord('78a96a1c', component.options)
    } else {
      api.reload('78a96a1c', component.options)
    }
    module.hot.accept("./ModalAddStep.vue?vue&type=template&id=78a96a1c&", function () {
      api.rerender('78a96a1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/components/trays/managementTray/modals/ModalAddStep.vue"
export default component.exports